import axios from "axios";
import { toast } from "react-toastify";
const baseUrl = process.env.REACT_APP_BASE_URL;

export const CREATE_THEME_CATEGORY_REQUEST = "CREATE_THEME_CATEGORY_REQUEST";
export const CREATE_THEME_CATEGORY_SUCCESS = "CREATE_THEME_CATEGORY_SUCCESS";
export const CREATE_THEME_CATEGORY_FAILURE = "CREATE_THEME_CATEGORY_FAILURE";

export const UPDATE_THEME_CATEGORY_REQUEST = "UPDATE_THEME_CATEGORY_REQUEST";
export const UPDATE_THEME_CATEGORY_SUCCESS = "UPDATE_THEME_CATEGORY_SUCCESS";
export const UPDATE_THEME_CATEGORY_FAILURE = "UPDATE_THEME_CATEGORY_FAILURE";

export const DELETE_THEME_CATEGORY_REQUEST = "DELETE_THEME_CATEGORY_REQUEST";
export const DELETE_THEME_CATEGORY_SUCCESS = "DELETE_THEME_CATEGORY_SUCCESS";
export const DELETE_THEME_CATEGORY_FAILURE = "DELETE_THEME_CATEGORY_FAILURE";

export const LIST_THEME_CATEGORY_REQUEST = "LIST_THEME_CATEGORY_REQUEST";
export const LIST_THEME_CATEGORY_SUCCESS = "LIST_THEME_CATEGORY_SUCCESS";
export const LIST_THEME_CATEGORY_FAILURE = "LIST_THEME_CATEGORY_FAILURE";

export const createThemeCategory = (data, toggle, setData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: CREATE_THEME_CATEGORY_REQUEST });
            const url = `${baseUrl}/occasion/create/category/v1`;
            const response = await axios.post(url, { ...data }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: CREATE_THEME_CATEGORY_SUCCESS, payload: response.data });
            toast("Music Category Created Successfully.");
            toggle();
            setData({
                name: "",
                icon: "",
                isInput: false,
                placeholder: ""
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: CREATE_THEME_CATEGORY_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const updateThemeCategory = (id, data, toggle, setData, setSelectedData) => {
    return async (dispatch) => {
        try {
            dispatch({ type: UPDATE_THEME_CATEGORY_REQUEST });
            let icon = "";

            const url = `${baseUrl}/occasion/update/category/${id}/v1`;
            const response = await axios.put(url, { ...data }, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: UPDATE_THEME_CATEGORY_SUCCESS, payload: response.data });
            toast("Music Updated Successfully.");
            toggle();
            setData({
                name: "",
                icon: "",
                isInput: false,
                placeholder: "",
            });
            setSelectedData({});
        } catch (error) {
            console.error(error);
            dispatch({ type: UPDATE_THEME_CATEGORY_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const deleteThemeCategory = (id, selectedData, toggle) => {
    return async (dispatch) => {
        try {
            dispatch({ type: DELETE_THEME_CATEGORY_REQUEST });
            const url = `${baseUrl}/occasion/delete/category/${id}/v1`;
            const response = await axios.delete(url, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: DELETE_THEME_CATEGORY_SUCCESS, payload: id });
            toast("Music Deleted Successfully.");
            toggle();
            selectedData({});
        } catch (error) {
            console.error(error);
            dispatch({ type: DELETE_THEME_CATEGORY_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};

export const listThemeCategory = (page, search) => {
    return async (dispatch) => {
        try {
            dispatch({ type: LIST_THEME_CATEGORY_REQUEST });
            const url = `${baseUrl}/occasion/admin/list/category/v1?skip=${page}&search=${search}`;
            const response = await axios.get(url, {
                headers: {
                    Authorization: localStorage.getItem("token")
                }
            });
            dispatch({ type: LIST_THEME_CATEGORY_SUCCESS, payload: response.data });
        } catch (error) {
            console.error(error);
            dispatch({ type: LIST_THEME_CATEGORY_FAILURE, payload: error.message });
            toast(error?.response?.data?.message);
        }
    }
};